const cards = [
  {
    id: 1,
    name: 'mushroom',
    img: require('./imgs/mushroom.png'),
  },
  {
    id: 2,
    name: '10 cts',
    img: require('./imgs/10cts.png'),
  },
  {
    id: 3,
    name: '20cts',
    img: require('./imgs/20cts.png'),
  },
  {
    id: 4,
    name: 'flower',
    img: require('./imgs/flower.png'),
  },
  {
    id: 5,
    name: 'life',
    img: require('./imgs/life.png'),
  },

  {
    id: 6,
    name: 'star',
    img: require('./imgs/star.png'),
  },
  {
    id: 7,
    name: 'mushroom',
    img: require('./imgs/mushroom.png'),
  },
  {
    id: 8,
    name: 'star',
    img: require('./imgs/star.png'),
  },

  {
    id: 9,
    name: '20cts',
    img: require('./imgs/20cts.png'),
  },
  {
    id: 10,
    name: 'flower',
    img: require('./imgs/flower.png'),
  },
  {
    id: 11,
    name: 'life',
    img: require('./imgs/life.png'),
  },
  {
    id: 12,
    name: 'star',
    img: require('./imgs/star.png'),
  },
  {
    id: 13,
    name: 'mushroom',
    img: require('./imgs/mushroom.png'),
  },
  {
    id: 14,
    name: 'flower',
    img: require('./imgs/flower.png'),
  },
  {
    id: 15,
    name: 'mushroom',
    img: require('./imgs/mushroom.png'),
  },

  {
    id: 16,
    name: 'flower',
    img: require('./imgs/flower.png'),
  },
  {
    id: 17,
    name: 'star',
    img: require('./imgs/star.png'),
  },
  {
    id: 18,
    name: '10 cts',
    img: require('./imgs/10cts.png'),
  },
];

export default cards;
